import {PulseIcon} from '@primer/octicons-react'
import {useSessionContext} from '../../contexts/SessionContext'
import styles from './RemoteSteeringEnabledEntry.module.css'

export function RemoteSteeringEnabledEntry() {
  const {taskSharingStatus} = useSessionContext()
  const isShared = taskSharingStatus === 'shared'

  return (
    <div className={styles.container}>
      <PulseIcon size={16} className={styles.icon} />
      <span className={styles.mainText}>Remote mode enabled</span>
      {!isShared && <span className={styles.secondaryText}> · Only you can see this session</span>}
    </div>
  )
}
